import { NICKNAME_CONFIG } from '@/constants/feedback';
import { NicknameGeneratorConfig, NicknameType } from '@/types/feedback';

export class NicknameGenerator {
  private static getRandomElement<T>(array: readonly T[]): T {
    return array[Math.floor(Math.random() * array.length)];
  }

  private static generateAnimeNickname(
    config: NicknameGeneratorConfig
  ): string {
    const hero = this.getRandomElement(config.animeHeroes);
    return hero; // Just return the hero name
  }

  private static generateLolNickname(config: NicknameGeneratorConfig): string {
    const champion = this.getRandomElement(config.lolChampions);
    return champion; // Just return the champion name
  }

  private static generateTechNickname(config: NicknameGeneratorConfig): string {
    const prefix = this.getRandomElement(config.techPrefixes);
    const suffix = this.getRandomElement(config.techSuffixes);
    return `${prefix} ${suffix}`; // No random number, just combine prefix and suffix
  }

  public static generate(type?: NicknameType): string {
    const randomType: NicknameType =
      type ?? this.getRandomElement<NicknameType>(['anime', 'lol', 'tech']);

    switch (randomType) {
      case 'anime':
        return this.generateAnimeNickname(NICKNAME_CONFIG);
      case 'lol':
        return this.generateLolNickname(NICKNAME_CONFIG);
      case 'tech':
        return this.generateTechNickname(NICKNAME_CONFIG);
      default:
        throw new Error(`Unhandled nickname type: ${randomType}`);
    }
  }
}
